// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__pboim","title":"style_title__DI6OV","body":"style_body__TqirM"};